import { put, takeEvery, select } from 'typed-redux-saga';
import { actionWeeklyReportLoadData } from './actions';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { takeLatest } from 'redux-saga/effects';
import { apiUserPatientProfileWeeklyReports } from 'services/user-patient-profile-weekly-reports';
import { selectWeeklyReportStatuses } from './selectors';

function* workerRefresh() {
  const { isMounted } = yield* select(selectWeeklyReportStatuses);
  
  if (!isMounted) return;

  yield* put(actionWeeklyReportLoadData());
}

export const weeklyReportSagas = [
  takeEvery(actionWeeklyReportLoadData.rejected, workerErrorNotifyThunk),
  takeLatest([apiUserPatientProfileWeeklyReports.endpoints.patchWeeklyReport.matchFulfilled], workerRefresh),
];
